module.exports = __webpack_public_path__ + "static/image/company/pc/image_conduct@3x.jpg?bc3af679";